import type { TFunction } from 'i18next'

import { parseListingDate } from './listingCardAvailability'

function startOfDay(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

function formatDayMonth(date: Date, locale: string): string {
  const day = date.getDate()
  const month = date.toLocaleDateString(locale, { month: 'long' })
  if (locale.toLowerCase().startsWith('fr') && day === 1) {
    return `1er ${month}`
  }
  return `${day} ${month}`
}

/** Always-visible availability line for listing cards. */
export function formatListingAvailabilityLabel(
  t: TFunction,
  availabilityRaw: string | null | undefined,
  locale = 'fr-CA'
): string {
  const availability = parseListingDate(availabilityRaw)
  if (!availability) {
    return String(t('propertyCard.availabilityTbd'))
  }

  const today = startOfDay(new Date())
  const day = startOfDay(availability)
  if (day.getTime() <= today.getTime()) {
    return String(t('propertyCard.availableNow'))
  }

  return String(
    t('propertyCard.availableFrom', {
      date: formatDayMonth(availability, locale),
    })
  )
}
